import { Typography } from '@material-ui/core'
import { useTranslate } from 'react-admin'
import FileWithContext from '../../../models/file_with_context'
import { darkGrey } from '../../../pages/ExtranetTickets/utils'
import UpsertFileButton from '../../file_upload'

const FactureInput = ({
  source,
  label,
  required,
  type,
  record,
  setPayload,
  payload,
  setRefresh,
  ...props
}) => {
  const translate = useTranslate()
  return (
    <>
      <UpsertFileButton
        labelButton={translate(label, { _: label })}
        height="100px"
        resource="file_with_context"
        copro_id={record?.copro_id}
        provider={record?.provider_id}
        documentType={FileWithContext.DOCUMENT_TYPE.COPRO}
        issuedBy={FileWithContext.ISSUED_BY.HELLO_APP}
        limitQuantity={1}
        validTypes={[FileWithContext.TYPE.INVOICE]}
        validCategories={[FileWithContext.CATEGORY.ACCOUNTING]}
        linkable_id={record.ticket_id}
        linkable_type="tickets"
        upload_by={record.token_id_internal}
        expectProvider={true}
        upload_by_type="prestataires"
        defaultValue={record.fwc.invoices ? record.fwc.invoices : []}
        readOnly={record.fwc.invoices.length >= 1}
        saveResult={({ accepted_files }) => {
          if (accepted_files) {
            const [{ amount_excl_vat, amount_incl_vat, purpose, url }] =
              accepted_files
            setPayload({
              ...payload,
              [source]: url,
              objFacture: {
                ticket_id: record.ticket_id,
                copro_id: record.copro_id,
                provider: record.token_id_internal,
                process5_facture: url,
                process5_montant_ht: amount_excl_vat,
                process5_montant_ttc: amount_incl_vat,
                process5_libelle: purpose,
              },
            })
            setRefresh(() => {
              return new Date().getTime()
            })
          }
        }}
      />
    </>
  )
}
export default FactureInput
